import React from "react";
import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { formatChartTitle } from "../../utils";

interface HorizontalBarChartData {
  label: string;
  value: number;
  [key: string]: string | number;
}

interface HorizontalBarChartProps {
  data: HorizontalBarChartData[];
  title?: string;
  height?: number;
  color?: string;
}

export const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  data,
  title,
  height,
  color = "#4DD0E1",
}) => {
  const formattedTitle = formatChartTitle(title);
  const minBarHeight = 40;
  const computedHeight = height ?? Math.max(300, data.length * minBarHeight);

  return (
    <Box sx={{ width: "100%" }}>
      {formattedTitle && (
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {formattedTitle}
        </Typography>
      )}
      <BarChart
        dataset={data}
        yAxis={[
          {
            scaleType: "band",
            dataKey: "label",
            width: 170,
            disableTicks: true,
          },
        ]}
        xAxis={[
          {
            scaleType: "linear",
            dataKey: "value",
            height: 30,
            disableTicks: true,
          },
        ]}
        series={[{ dataKey: "value", color: color }]}
        layout="horizontal"
        height={computedHeight}
        // Top/bottom margin so the first and last band tick labels aren't
        // clipped against the chart edges (e.g. long role names like
        // "Connections Team Leader").
        margin={{ left: 0, right: 0, top: 12, bottom: 12 }}
        grid={{ vertical: true }}
        borderRadius={6}
      />
    </Box>
  );
};
